$(document).ready(function () {
    const closeMenu = () => {
        const $toggler = $('.toggler i');
        const $dlMenu = $('#dl-menu');
        $dlMenu.dlmenu('closeMenu');
        $toggler.removeClass('mdi-close');
        $toggler.addClass('mdi-menu');

        // The timeout should be the same as the CSS transition duration.
        setTimeout(() => $dlMenu.hide(), 400);
        $('body').removeClass('remove_scroll');
        $('#topnav').removeClass('dl-custom-slideout');
        $('.hero-container').removeClass('dl-custom-slideout');
        $('.hero-jobs-container').removeClass('dl-custom-slideout');
        $('main').removeClass('dl-custom-slideout');
        $('#responsive_content').removeClass('dl-custom-slideout'); // Blog
        $('.footer').removeClass('dl-custom-slideout');

        $(document).off('click.mobile-menu');
    };

    const onClickOutsideMenu = (event) => {
        // Don't manually close if the click originated from the actual menu
        // or the menu toggler.
        if ($(event.target).closest('.dl-menu,.toggler').length === 0) {
            $('.toggler').removeClass('open');
            closeMenu();
        }
    };

    const openMenu = () => {
        const $toggler = $('.toggler i');
        $toggler.removeClass('mdi-menu');
        $toggler.addClass('mdi-close');
        $('#dl-menu').show().dlmenu('openMenu');
        $('body').addClass('remove_scroll');
        $('#topnav').addClass('dl-custom-slideout');
        $('.hero-container').addClass('dl-custom-slideout');
        $('.hero-jobs-container').addClass('dl-custom-slideout');
        $('main').addClass('dl-custom-slideout');
        $('#responsive_content').addClass('dl-custom-slideout'); // Blog
        $('.footer').addClass('dl-custom-slideout');

        // Close the menu if the user clicks outside of it.
        $(document).on('click.mobile-menu', onClickOutsideMenu);
    };

    let mobileMenuInitialized = false;

    const initMobileMenu = () => {
        $('#dl-menu').hide().dlmenu({
            animationClasses: {
                classin: 'dl-animate-in-2',
                classout: 'dl-animate-out-2',
            },
        });

        if (/iPhone|iPad/.test(navigator.userAgent)) {
            $('*').css('cursor', 'pointer');
        }

        mobileMenuInitialized = true;
    };

    const enableMobileMenu = () => {
        if (!mobileMenuInitialized) {
            initMobileMenu();
        }

        $('.custom-nav-hide').hide();
    };

    const disableMobileMenu = () => {
        $('.mobile_menu_hide').hide();
        $('.custom-nav-hide').show();
    };

    const checkNeedsMobileMenu = () => {
        if ($(window).width() <= 991) {
            enableMobileMenu();
        } else {
            disableMobileMenu();
        }
    };

    checkNeedsMobileMenu();

    $(window).on('resize', checkNeedsMobileMenu);

    $(document).on('click', '.toggler', function () {
        if ($('.toggler').hasClass('open')) {
            openMenu();
        } else {
            closeMenu();
        }
    });

    $('.hasSubmenu > a').click(function () {
        const prevText = $(this).find('span').text();
        $(this).parent().find('.dl-submenu:first > .dl-back:first > a:first')
            .html('<i class="mdi mdi-cheveron-left dl-custom-nav md"></i>'+prevText);
    });

    $('.dl-toggle-container').on('click', function () {
        const $toggle = $(this).find('.dl-toggle');

        if ($toggle.hasClass('on')) {
            $toggle.siblings('input').prop('checked', false);
            $toggle.removeClass('on');
        } else {
            $toggle.siblings('input').prop('checked', true);
            $toggle.addClass('on');
        }
    });
});
